import { render, staticRenderFns } from "./FieldOptions.vue?vue&type=template&id=27683a20&scoped=true&"
import script from "./FieldOptions.vue?vue&type=script&lang=js&"
export * from "./FieldOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27683a20",
  null
  
)

export default component.exports